import api from "../../api/api";
import {openNotificationWithIcon} from "../notificationService";
import {
    CLEAR_UNIT_CONTRACTS,
    SET_UNIT_CONTRACT,
    SET_UNIT_CONTRACTS,
    TOGGLE_UNIT_CONTRACTS_FAILED,
    UNIT_CONTRACTS_LOADING,
    SET_UNIT_CONTRACT_UNITS,
    SET_CREATE_BOOKING_SELECTED_UNIT,
    SET_CREATE_BOOKING_LOADING
} from "../actionTypes";

export function bootstrapOwnerPortalApp() {
    return dispatch => {
        dispatch(toggleUnitContractsLoading(true));
        dispatch(toggleUnitContractsFailed(false));

        api.get('unitContracts', {data: null})
            .then(
                response => {
                    if(response !== undefined && response.data !== undefined && response.data.content !== undefined) {
                        dispatch(setUnitContracts(response.data.content));
                        dispatch(setSingleUnitContract(response.data.content && response.data.content.length > 0 ? response.data.content[0].id : false));
                        dispatch(toggleUnitContractsLoading(false));
                        dispatch(toggleUnitContractsFailed(false));
                    }
                })
            .catch(error => {
                if(error !== undefined && error.response !== undefined && error.response.status !== undefined && error.response.status === 426) {
                    return;
                }
                //dispatch(toggleBookingsFailed(true));
                if(error && error.response && error.response.status !== 403) {
                    openNotificationWithIcon('error', 'Error', 'There has been an error processing your request, please try again.');
                }
            })
            .then(() => {
                dispatch(toggleUnitContractsLoading(false));
            });
    };
}

export function toggleUnitContractsLoading(toggle) {
    return {
        type: UNIT_CONTRACTS_LOADING,
        toggle
    }
}

export function toggleUnitContractsFailed(failed) {
    return {
        type: TOGGLE_UNIT_CONTRACTS_FAILED,
        failed
    }
}

export function setUnitContracts(data) {
    return {
        type: SET_UNIT_CONTRACTS,
        data
    }
}

export function setSingleUnitContract(unitContractId, history = false, route) {
    return {
        type: SET_UNIT_CONTRACT,
        unitContractId,
        history,
        route
    }
}


export function clearUnitContracts() {
    return {
        type: CLEAR_UNIT_CONTRACTS
    }
}

export function getUnits(unitContractId) {
	return (dispatch) => {
		api.get(`unitContracts/${unitContractId}/units`, {data: null})
			.then(
				response => {
                    let units = response.data.units;
                    dispatch(setUnitContractUnits(units));
				})
			.catch(error => {
				return error;
			})
			.then(() => {
				// dispatch some kind of loading here
			});
    };
}

export function setUnitContractUnits(data) {
    return {
        type: SET_UNIT_CONTRACT_UNITS,
        data
    }
}

export function setCreateBookingSelectUnit(selectedUnitId) {
    return {
        type: SET_CREATE_BOOKING_SELECTED_UNIT,
        selectedUnitId
    }
}

export function toggleSetCreateBookingLoading(createBookingloading) {
    return {
        type: SET_CREATE_BOOKING_LOADING,
        toggle: createBookingloading
    }
}

export function createBookingFromSelectedUnit(selectedUnitContractId, selectedUnitId, startDate, endDate) {
	return (dispatch) => { 
        dispatch(toggleSetCreateBookingLoading(true));
        return new Promise(function(resolve, reject) { 
            const urlAvailability = `unitContracts/${selectedUnitContractId}/availability`;
            const params = {
                unitId: selectedUnitId,
                startDate,
                endDate
            }
            api.get(urlAvailability + "?" + new URLSearchParams(params).toString(), {data: null})
                .then(response => {
                    // Unit is available
                    if (response.data) {
                        const urlCreateBooking = `bookings/create`;
                        api.post(urlCreateBooking, {
                            ...params
                        })
                        .then(createResponse => {
                            if (createResponse.data) {
                                console.log('booking created')
                                resolve(createResponse);
                            }
                            else
                            {
                                reject(new Error("Booking failed to be created."));
                            }
                            console.log("dispa 0")
                            dispatch(toggleSetCreateBookingLoading(false));
                        })
                        .catch(error => {
                            console.log('no booking')
                            reject(error);
                            console.log("dispa 1")
                            dispatch(toggleSetCreateBookingLoading(false));
                        })
                    }
                    else
                    {
                        reject(new Error("Unit is not available for selected dates."));
                        console.log("dispa 2")
                        dispatch(toggleSetCreateBookingLoading(false));
                    }
                })
                .catch(error => {
                    reject(error);
                    console.log("dispa 3")
                    dispatch(toggleSetCreateBookingLoading(false));
                });
        // new Promise(function(resolve, reject) {
        });
    }
}